import React from 'react'
import PropTypes from 'prop-types'
import { isObject } from 'lodash'
import {
  Select, FormHelperText, MenuItem, Box,
} from '@material-ui/core'

import makeStyles from '@material-ui/core/styles/makeStyles'
import AutomaticTooltip from '../../../pages/price/quotations/AutomaticTooltip'
import { ReactComponent as Automatic } from '../../../assets/img/icons/ico-automatico.svg'

const useStyles = makeStyles((theme) => ({
  customSelect: {
    '& select': {
      [theme.breakpoints.down('xs')]: {
        WebkitAppearance: 'none',
      },
    },
    '& .MuiSelect-select': {
      paddingRight: '50px !important',
    },
    '& .MuiSelect-selectMenu': {
      paddingRight: '50px !important',
    },
  },
  item: {
    [theme.breakpoints.down('xs')]: {
      whiteSpace: 'normal',
      maxWidth: '100vw',
      marginLeft: 10,
      marginBottom: 5,
      borderBottom: '1px solid #8080802e',
      '& li': {
        WebkitAppearance: 'none',
      },
    },
  },
  selectContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
  },
  selectText: {
    marginLeft: 8,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}))
const DropdownSelectOne = (props) => {
  const {
    id, options, color, error, helpertext, renderIcon,
  } = props

  const classes = useStyles()

  return (
    <>
      <Select
        {...props}
        htmlFor={id}
        color={color}
        error={error}
        className={classes.customSelect}
        renderValue={(selected) => {
          const selectedOption = options.find((opt) => {
            const optValue = !isObject(opt) ? opt : opt?.value ?? opt?.text
            return optValue === selected
          })
          const selectedText = !isObject(selectedOption) ? selectedOption : selectedOption?.text
          const hasIcon = isObject(selectedOption)
          && selectedOption.hasAutomaticEmission && renderIcon

          return hasIcon ? (
            <Box className={classes.selectContent}>
              <AutomaticTooltip text="Passível de Emissão Automática">
                <Box display="flex" alignItems="center" style={{ width: 15, height: 15 }}>
                  <Automatic style={{ width: '100%', height: '100%', display: 'block' }} />
                </Box>
              </AutomaticTooltip>
              <span className={classes.selectText}>{selectedText}</span>
            </Box>
          ) : (
            selectedText
          )
        }}
        MenuProps={{
        }}
      >
        {
          options.map((option, index) => {
            const optionValue = !isObject(option) ? option : option?.value ?? option?.text
            const optionText = !isObject(option) ? option : option.text
            const hasIcon = isObject(option) && option.hasAutomaticEmission && renderIcon

            return (
              <MenuItem
                key={index}
                style={{ whiteSpace: 'normal' }}
                className={classes.item}
                value={optionValue}
              >
                {hasIcon ? (
                  <Box display="flex" alignItems="center">
                    <AutomaticTooltip text="Passível de Emissão Automática">
                      <Box display="flex" alignItems="center" style={{ width: 15, height: 15 }}>
                        <Automatic style={{ width: '100%', height: '100%', display: 'block' }} />
                      </Box>
                    </AutomaticTooltip>
                    <span style={{ marginLeft: 8 }}>{optionText}</span>
                  </Box>
                ) : (
                  optionText
                )}
              </MenuItem>
            )
          })
        }
      </Select>
      <FormHelperText hidden={!error} error={error}>{helpertext}</FormHelperText>
    </>
  )
}

DropdownSelectOne.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary']),
  error: PropTypes.bool,
  options: PropTypes.array,
  helpertext: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  renderIcon: PropTypes.func,
}

DropdownSelectOne.defaultProps = {
  color: 'secondary',
  error: false,
  options: [''],
  helpertext: '',
  label: '',
  name: undefined,
  onChange: () => { },
  renderIcon: null,
}

export default DropdownSelectOne
